export enum RenderDrawMode{
    TRIANGLES,
    POINTS,
    LINES
}